import { Form, Select, Button } from "antd";
import { useState } from "react";
import { userApi } from "../../../../api/useApi";

export function AddUserToEventModal({
  eventId,
  event,
  onClose,
  adminAddUserToEvent,
  onSuccess,
}) {
  const [addUserForm] = Form.useForm();
  const [selectedUser, setSelectedUser] = useState(null);
  const [userOptions, setUserOptions] = useState([]);
  const [userLoading, setUserLoading] = useState(false);

  const searchUsers = async (searchTerm) => {
    if (!searchTerm) {
      setUserOptions([]);
      return;
    }
    setUserLoading(true);
    try {
      const response = await userApi.getAll({
        search: searchTerm,
        page: 1,
        limit: 10,
      });
      const users = response?.data || [];
      setUserOptions(
        users.map((u) => ({
          label: `${u.name} (${u.email})`,
          value: u._id,
        }))
      );
    } catch (error) {
      console.error("Search users error:", error);
      setUserOptions([]);
    } finally {
      setUserLoading(false);
    }
  };

  const handleAddUser = async (values) => {
    try {
      await adminAddUserToEvent.mutateAsync({
        eventId,
        userId: values.userId,
        isTakingRefuge: values.isTakingRefuge || false,
      });
      addUserForm.resetFields();
      setSelectedUser(null);
      setUserOptions([]);
      onSuccess?.();
      onClose();
    } catch (error) {
      // error handled by mutation
    }
  };

  const handleCancel = () => {
    addUserForm.resetFields();
    setSelectedUser(null);
    setUserOptions([]);
    onClose();
  };

  return (
    <Form
      form={addUserForm}
      layout="vertical"
      onFinish={handleAddUser}
      autoComplete="off"
    >
      <Form.Item
        label="Tìm kiếm người dùng"
        name="userId"
        rules={[{ required: true, message: "Vui lòng chọn người dùng!" }]}
      >
        <Select
          showSearch
          placeholder="Nhập tên, email hoặc số điện thoại để tìm kiếm"
          filterOption={false}
          onSearch={searchUsers}
          onChange={(value) => setSelectedUser(value)}
          options={userOptions}
          loading={userLoading}
          notFoundContent={
            userLoading ? "Đang tìm kiếm..." : "Không tìm thấy người dùng"
          }
          style={{ width: "100%" }}
        />
      </Form.Item>

      {event?.hasRefugeCeremony && (
        <Form.Item
          label="Quy Y Tam Bảo"
          name="isTakingRefuge"
          initialValue={false}
        >
          <Select
            options={[
              { value: true, label: "Tham dự" },
              { value: false, label: "Không tham dự" },
            ]}
          />
        </Form.Item>
      )}

      <Form.Item>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <Button onClick={handleCancel}>Hủy</Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={adminAddUserToEvent?.isPending}
          >
            Thêm vào sự kiện
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
}
